import type { EntityIdentityNormalizationState } from '@cli-types/core-engine/schema-reader.js'
import type { Schema } from '@cli-types/core-engine/schema.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'
import { createGeneratedSlugField } from './create-generated-slug-field.js'
import { hasPersistedTitleField } from './has-persisted-title-field.js'
import { isEntitySlugField } from './is-entity-slug-field.js'
import { normalizeEntityIdentityFields } from './normalize-entity-identity-fields.js'

export function ensureEntitySlugField(schema: Schema): Schema {
  const sourceField = hasPersistedTitleField(schema.fields) ? 'title' : undefined
  const hasAuthoredSlugField = flattenFields(schema.fields).some(isEntitySlugField)
  const state: EntityIdentityNormalizationState = {
    sourceField,
    hasAuthoredSlugField,
    keptAuthoredSlugField: false,
    generatedSlugInserted: false
  }
  const normalizedFields = normalizeEntityIdentityFields(schema.fields, schema.fields, state)

  if (hasAuthoredSlugField || state.generatedSlugInserted) {
    return {
      ...schema,
      fields: normalizedFields
    }
  }

  const insertIndex = Math.min(normalizedFields.length, 1)
  const fields = [
    ...normalizedFields.slice(0, insertIndex),
    createGeneratedSlugField(schema.fields),
    ...normalizedFields.slice(insertIndex)
  ]

  return {
    ...schema,
    fields
  }
}
